import React from "react"

import globalStyles from "../../../../App.module.scss";

export default function Inodes() {
    return (
        <div className={globalStyles.article}>
            <h1>Inodes explained</h1>

            <p>An <b>inode</b> stores a file's metadata — permissions, owner, timestamps, size, pointers to the
                data blocks — everything except the filename and the data itself. A filesystem has a fixed
                number of inodes created at format time, so it's possible to run out of them while disk space
                is still free.</p>

            <h3>"No space left on device" with free space available</h3>
            <p>If <code>df -h</code> shows free space but you still can't create files, check inode usage:</p>
            <pre className={globalStyles.code}>
    <b>user@host:~$</b> df -h /var <i># disk space</i><br/>
    <b>user@host:~$</b> df -i /var <i># inode usage — this is the one that matters here</i><br/>
            </pre>
            <pre className={globalStyles.code}>
Filesystem      Inodes  IUsed   IFree IUse% Mounted on<br/>
/dev/sda1      1310720 1310720      0  100% /var<br/>
            </pre>

            <p>This is common on systems with huge numbers of tiny files: mail queues, session file stores,
                cache directories, or a runaway process writing lots of small temp files.</p>

            <h3>Finding what's eating inodes</h3>
            <pre className={globalStyles.code}>
    <b>root@host:~#</b> for dir in /var/*; do echo "$dir: $(find "$dir" | wc -l)"; done<br/>
    <b>root@host:~#</b> find /var/spool/mail -type f | wc -l<br/>
            </pre>

            <h3>Other inode commands</h3>
            <pre className={globalStyles.code}>
    <b>user@host:~$</b> ls -i notes.txt <i># show a file's inode number</i><br/>
    <b>user@host:~$</b> stat notes.txt <i># full metadata, including inode</i><br/>
    <b>root@host:~#</b> find / -xdev -inum 123456 <i># find every filename linked to a given inode</i><br/>
            </pre>

            <p>Two directory entries with the same inode number are <b>hard links</b> to the same file — deleting
                one just removes that entry, the data stays until the last link is gone.</p>

            <p>The number of inodes on a filesystem is normally fixed at format time (<code>mkfs -N</code> for
                ext), so if you hit this limit chronically, the real fix is reformatting with more inodes or
                moving the small-file workload to its own filesystem — not just deleting files.</p>
        </div>
    )
}
